// extracted by mini-css-extract-plugin
export var container = "FallingSquare-module--container--3sZ5H";
export var transition = "FallingSquare-module--transition--2M1xQ";
export var squareWrap = "FallingSquare-module--squareWrap--1EQ7s";